// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6528aea2","910":"deceac4b"}[chunkId] + ".chunk.js";
};